// eslint-disable-next-line camelcase
import { unstable_styleFunctionSx } from '@mui/system';
import { styled } from '@mui/material/styles';
import { GatsbyImage } from 'gatsby-plugin-image';

export default styled(GatsbyImage)(unstable_styleFunctionSx);
